/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import classnames from 'classnames';
import { colord } from "colord";

// below here for testing imports
import { PanelBody,RangeControl,ToggleControl } from '@wordpress/components';

const { assign, merge } = lodash;
const { __ } = wp.i18n;


const FiltersPanel = (myprops) => {

// Need to understand what I am passing here
	const props = myprops.props
	const {attributes,setAttributes} = props;
	const {aplofilters, aplofiltersHover, backdropFilter, hasFilters, hasHoverFilters,galleryswitch} = props.attributes;


	const backdropFilterToggle = () => {

		if (typeof backdropFilter === 'undefined') {
			return
		}

		return (

		<ToggleControl
			label="Backdrop"
			checked={ backdropFilter }
			onChange={ (state) => {
				setAttributes({ backdropFilter: state })
			} }
		/>
		)
	}

	const galleryswitchToggle = () => {

		if (typeof galleryswitch === 'undefined') {
			return
		}
//__('Gallery Switch - when true the hover state gets applied to the images in the gallery that are not hovered over','aploblocks')
		return (
		<>
		<p>{__('When Gallery Switch is true the hover state gets applied to the images in the gallery that are not hovered over','aploblocks')}</p>
		<ToggleControl
			label={__('Gallery Switch','aploblocks')}
			checked={ galleryswitch }
			onChange={ (state) => {
				//const att = state ? state : undefined;
				setAttributes({ galleryswitch: state })
			} }
		/>
		</>
		)
	}


	function rangeControlFilters(thename, min, max, position) {

		function updateValue(value) {
			if (value === undefined && aplofilters === undefined) {return};
			if (value === undefined) { // value is undefined then we may be removing a value
				// if the old value is not undefined the value is undefined then remove the value
				if (aplofilters !== undefined && aplofilters[thename] !== undefined) {
					hasFilters === 1 ? setAttributes({aplofilters:undefined}) : setAttributes({aplofilters:{...aplofilters,[thename]:undefined}});
					setAttributes({hasFilters:hasFilters - 1 });
				}
			} else { //  the value is defined, adding or changing value
				if (aplofilters === undefined || aplofilters[thename] === undefined) { setAttributes({hasFilters:hasFilters + 1}); };
				setAttributes({aplofilters:{...aplofilters,[thename]:value}});
			}
		}
			
		return(
			<RangeControl
				/*label={thename}*/
				/*value={ aplofilters[thename] ? aplofilters[thename] : undefined }*/
				value={ aplofilters !== undefined ? aplofilters[thename] : undefined}
				onChange={ updateValue }
				min={ min }
				max={ max }
				step={1}
			/*	initialPosition={5} removed the initial position to make it clearer when nothing has been set */
				allowReset={true}
			/>
		);
	}
	
	function rangeControlFiltersHover(thename, min, max,position) {
		function updateValue(value) {
			if (value === undefined && aplofiltersHover === undefined) {return};
			if (value === undefined) { // value is undefined then we may be removing a value
				// if the old value is not undefined the value is undefined then remove the value
				if (aplofiltersHover !== undefined && aplofiltersHover[thename] !== undefined) {
					hasHoverFilters === 1 ? setAttributes({aplofiltersHover:undefined}) : setAttributes({aplofiltersHover:{...aplofiltersHover,[thename]:undefined}});
					setAttributes({hasHoverFilters:hasHoverFilters - 1 });
				}
			} else { //  the value is defined, adding or changing value
				if (aplofiltersHover === undefined || aplofiltersHover[thename] === undefined) { setAttributes({hasHoverFilters:hasHoverFilters + 1}); };
				setAttributes({aplofiltersHover:{...aplofiltersHover,[thename]:value}});
			}
		}	
	
		return(
			<RangeControl
				/*label={thename}*/
				value={ aplofiltersHover !== undefined ? aplofiltersHover[thename] : undefined}
				onChange={ updateValue }
				min={ min }
				max={ max }
				step={1}
				/*initialPosition = {position}*/
				allowReset={true}
			/>
		);
	}
	

	return (
<>
		<PanelBody title={__('Aplo Filter Styles', 'aploblocks')} initialOpen={false} className="aplofilterstyles">

						
		{typeof backdropFilter !== 'undefined' ?	backdropFilterToggle() : ''}
		{typeof galleryswitch !== 'undefined' ?	galleryswitchToggle() : ''}
		<p>{__('Set the values and hover values for each filter.  The left hand value is normal and the right hand value is hover','aploblocks')}</p>
		<div class="aploranges">
			<h2>{__('Blur','aploblocks')}</h2>
			<div class="aplorange">
				{rangeControlFilters("blur",0,100,0
				)}
				{rangeControlFiltersHover("blur",0,100,0)}
			</div>
			<h2>{__('Grayscale','aploblocks')}</h2>
			<div class="aplorange">
				{rangeControlFilters("grayscale",0,100,0)}
				{rangeControlFiltersHover("grayscale",0,100,0)}
			</div>
			<h2>{__('Sepia','aploblocks')}</h2>
			<div class="aplorange">
				{rangeControlFilters("sepia",0,100,0)}
				{rangeControlFiltersHover("sepia",0,100,0)}
			</div>
			<h2>{__('Hue','aploblocks')}</h2>
			<div class="aplorange">
				{rangeControlFilters("hue",0,360,0)}
				{rangeControlFiltersHover("hue",0,360,0)}
			</div>
			<h2>{__('Opacity','aploblocks')}</h2>
			<div class="aplorange">
				{rangeControlFilters("opacity",0,100,99)}
				{rangeControlFiltersHover("opacity",0,100,100)}
			</div>
			<h2>{__('Invert','aploblocks')}</h2>
			<div class="aplorange">
				{rangeControlFilters("invert",0,100,0)}
				{rangeControlFiltersHover("invert",0,100,0)}
			</div>
			<h2>{__('Brightness','aploblocks')}</h2>
			<div class="aplorange">
				{rangeControlFilters("brightness",0,500,100)}
				{rangeControlFiltersHover("brightness",0,500,100)}
			</div>
			<h2>{__('Contrast','aploblocks')}</h2>
			<div class="aplorange">
				{rangeControlFilters("contrast",0,500,100)}
				{rangeControlFiltersHover("contrast",0,500,100)}
			</div>
			<h2>{__('Saturate','aploblocks')}</h2>
			<div class="aplorange">
				{rangeControlFilters("saturate",0,500,100)}
				{rangeControlFiltersHover("saturate",0,500,100)}
			</div>
		</div>
		
	</PanelBody>


	<PanelBody title={__('Aplo Shadow Filter', 'aploblocks')} initialOpen={false} className="aplofilterstyles">
	<p>{__('Set the Normal and hover values for the drop shadow filter','aploblocks')}</p>
	<h2>{__('Drop Shadow','aploblocks')}</h2>
	X-offset:{rangeControlFilters("dsx",-30,30,0)}
	Y-offset:{rangeControlFilters("dsy",-30,30,0)}
	Blur:{rangeControlFilters("dsb",0,30,0)}
	Opacity:{rangeControlFilters("dso",0,100,0)}

	<h2>{__('Drop Shadow Hover','aploblocks')}</h2>
	X-offset:{rangeControlFiltersHover("dsx",-30,30,0)}
	Y-offset:{rangeControlFiltersHover("dsy",-30,30,0)}
	Blur:{rangeControlFiltersHover("dsb",0,30,0)}
	Opacity:{rangeControlFiltersHover("dso",0,100,0)}
	</PanelBody>
	</>


	)




}



export default FiltersPanel